import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <span className="text-secondary-500">/</span>
            {item.to ? (
              <Link to={item.to} className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-primary-500 whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}